import React from "react";

export default function VideoViewer({
  id,
  keySet,
  filePathToSet,
  disableFullScreen,
}) {
  return (
    <video
      id={id}
      key={keySet}
      width="100%"
      height="100%"
      controls
      controlsList={disableFullScreen === true ? "nofullscreen" : undefined}
    >
      <source src={filePathToSet} type="video/mp4" />
    </video>
  );
}
